import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button, Stack } from '@mui/material';
import { CheckboxField, InputField } from 'components/form';
import { LenderDeskingPanelFormValues } from '../../../types';

interface Props {
  isProposalProcessing: boolean;
  onSaveAsDraft: VoidFunction;
  isSectionDisabled?: boolean;
  onSendToApplicant: VoidFunction;
}

export const ActionsSection = ({
  onSaveAsDraft,
  isSectionDisabled,
  onSendToApplicant,
  isProposalProcessing,
}: Props) => {
  const { control } = useFormContext<LenderDeskingPanelFormValues>();

  return (
    <Stack gap="1rem">
      <CheckboxField
        control={control}
        label="Default Terms and Conditions"
        name="actions.isUseDefaultTermsAndConditions"
        checkboxProps={{ disabled: isSectionDisabled }}
      />

      <InputField
        control={control}
        name="actions.additionalInfo"
        label="Additional Information"
        inputProps={{
          minRows: 7,
          maxRows: 7,
          multiline: true,
          variant: 'outlined',
          disabled: isSectionDisabled,
          placeholder: 'Enter additional Information...',
        }}
      />

      <Stack direction="row" gap="1rem" alignItems="flex-start">
        <Stack gap="0.2rem">
          <Button variant="contained" loading={isProposalProcessing} onClick={onSendToApplicant}>
            Send to Applicant
          </Button>

          <CheckboxField control={control} name="actions.ccToDealer" label="CC Dealer" />
        </Stack>

        <Button loading={isProposalProcessing} onClick={onSaveAsDraft}>
          Save as draft
        </Button>
      </Stack>
    </Stack>
  );
};
